module.exports = __webpack_public_path__ + "files/e9b5eaea799a212e5a11ec886855a1fe.png";